export const pluralizePoiType = (slug) => {
    const map = {
        hrib: 'Hribi',
        planina: 'Planine',
        koca: 'Koče',
        jezero: 'Jezera',
        'razgledni-stolp': 'Razgledni stolpi',
        bivak: 'Bivaki',
        kopalisce: 'Kopališča',
        slap: 'Slapovi',
        jama: 'Jame',
        cerkev: 'Cerkve',
        grad: 'Gradovi',
        izvir: 'Izviri',
        'muzej-na-prostem': 'Muzeji na prostem',
        'sup-tocka': 'Sup točke',
        ferata: 'Ferate',
        dvorec: 'Dvorci',
        soteska: 'Soteske',
        park: 'Parki',
        drugo: 'Drugo',
        drsalisce: 'Drsališča',
        'pravljicna-pot': 'Pravljične poti'
    };

    return map[slug] || slug;
};
